module.exports = __webpack_public_path__ + "img/skin-detail-msu-spec-block.ab3be09.jpg";